import { UseQueryOptions } from '@tanstack/react-query';

import { agentConfigGetSequencerDevices } from '@repo/sdk/funcs/agentConfigGetSequencerDevices';
import { SequencerDevice } from '@repo/sdk/models/components';
import { SDKError } from '@repo/sdk/models/errors';
import { GetSequencerDevicesRequest } from '@repo/sdk/models/operations';

import { GaiaClientFunction } from '@/client/types';
import { displayTemplateSourceKey } from '@/queries/gaia-api/display-template-source-key';
import { GaiaQueryWithAgentId } from '@/queries/types';

interface GetSequencerDevicesQueryProps extends GaiaQueryWithAgentId {
  client: GaiaClientFunction;
}

export const getSequencerDevicesQuery = ({
  agentId,
  client,
}: GetSequencerDevicesQueryProps): UseQueryOptions<
  SequencerDevice[],
  SDKError,
  SequencerDevice[] | undefined
> => ({
  enabled: !!agentId,
  queryKey: [agentId, 'getSequencerDevices', displayTemplateSourceKey(client)],
  queryFn: () =>
    client<GetSequencerDevicesRequest, SequencerDevice[]>({
      gaiaFunc: agentConfigGetSequencerDevices,
      request: { agentId: agentId! },
    }),
  staleTime: 5 * 60 * 1000,
});
